<!--
/**
 * DjRebateTab.vue - 返销记录 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的返销记录查询页面，
 * 用于查询充值返销（撤销充值）的历史记录。支持按号码搜索，
 * 展示返销的号码、金额、时间和流水号等信息。
 *
 * 【主要功能】
 * 1. 返销记录查询 - 按号码搜索返销记录
 * 2. 流水号复制 - 点击可复制返销流水号
 *
 * 【权限要求】
 * - 所有用户：可查询返销记录
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query9.phone" clearable maxlength="12" placeholder="号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <!-- 搜索按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                 @click="getReturnPremiumRecord" class="m_t_10">搜索
      </el-button>
    </div>

    <!-- ========== 返销记录表格 ========== -->
    <el-table :data="tableData9" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              v-loading="loading">
      <!-- 号码 -->
      <el-table-column prop="phone" label="号码" align="center"></el-table-column>
      <!-- 返销金额 -->
      <el-table-column prop="amount" label="金额(元)" align="center"></el-table-column>
      <!-- 返销时间 -->
      <el-table-column prop="time" label="时间" align="center"></el-table-column>
      <!-- 流水号（点击可复制） -->
      <el-table-column label="流水号" align="center">
        <template #default="scope">
          <span style="cursor: pointer;">
            <span @click="copyUrl(scope.row.uid)">{{ scope.row.uid }}</span>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query9.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query9.pageSize" :total="pageTotal9" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 返销记录 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - ReturnPremiumRecord：查询返销记录列表
 */
import {
  ReturnPremiumRecord
} from '../../../api/dijia.js';

export default {
  name: 'DjRebateTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   */
  props: {
    theme: { type: String, default: '' },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      query9: {                 // 查询参数
        phone: '',              // 号码
        userId: localStorage.getItem('user'),
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
      },
      tableData9: [],           // 返销记录列表
      pageTotal9: 0,            // 总条数
    };
  },

  /**
   * 组件创建时查询返销记录列表
   */
  created() {
    this.getReturnPremiumRecord();
  },

  methods: {
    /**
     * getReturnPremiumRecord - 查询返销记录列表
     */
    getReturnPremiumRecord() {
      this.loading = true;
      ReturnPremiumRecord(this.query9).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData9 = res.data.list;
          this.pageTotal9 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * copyUrl - 复制文本到剪贴板
     * @param {string} item - 要复制的文本
     */
    copyUrl(item) {
      let cInput = document.createElement('input');
      cInput.value = item;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      this.$message.success('复制成功');
      document.body.removeChild(cInput);
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query9.pageIndex = val;
      this.getReturnPremiumRecord();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query9.pageSize = val;
      this.query9.pageIndex = 1;
      this.getReturnPremiumRecord();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
